<template>
  <div class="conversations">
    <AppLayout customToolbar centered>
      <template v-slot:body>
        <div class="container col-lg-8 col-sm-12">
          <BaseListToolbar
            title="Conversations"
            @search="val => (search = val)"
          />
          <v-tabs v-model="selectedTab" class="basic-tabs" centered>
            <v-tab v-for="(section, key) in sections" :key="key">
              {{ section }}
            </v-tab>
          </v-tabs>
          <v-tabs-items class="mt-2" v-model="selectedTab">
            <v-tab-item>
              <ConversationList
                :isBookingConversation="isBookingConversation"
                :search="search"
                category="inbound"
              />
            </v-tab-item>
            <v-tab-item>
              <ConversationList
                :isBookingConversation="isBookingConversation"
                :search="search"
                category="outbound"
              />
            </v-tab-item>
          </v-tabs-items>
        </div>
        <BaseFooter v-if="!isBookingConversation">
          <Permissioned
            :vertical="isMobile"
            section="conversations"
            class="actions-bar"
          >
            <NewMessageAction permission="create" />
          </Permissioned>
        </BaseFooter>
      </template>
    </AppLayout>
  </div>
</template>

<script>
import ConversationList from "@/views/conversations/ConversationList";
import AppLayout from "@/components/common/base-layouts/AppLayout";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import Permissioned from "@/components/common/Permissioned";
import BaseFooter from "@/components/common/BaseFooter";
import NewMessageAction from "@/views/conversations/actions/NewMessageAction";

export default {
  name: "Conversations",
  props: {
    isBookingConversation: Boolean
  },
  data() {
    return {
      search: "",
      isOpen: true,
      excludeOutboundOnly: true,
      selectedTab: 0,
      sections: ["Inbound", "Sent"]
    };
  },
  components: {
    AppLayout,
    ConversationList,
    BaseListToolbar,
    BaseFooter,
    Permissioned,
    NewMessageAction
  }
};
</script>

<style lang="scss"></style>
